import { render } from "./inspectionRecords.vue?vue&type=template&id=7e4e0ca7&scoped=true"
import script from "./inspectionRecords.vue?vue&type=script&lang=js"
export * from "./inspectionRecords.vue?vue&type=script&lang=js"

import "./inspectionRecords.vue?vue&type=style&index=0&id=7e4e0ca7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e4e0ca7"

export default script